<template>
  <div class="author-info">
    <div class="header-title">
      <span class="num">#{{ num }}</span>
      <a @click.stop="showProfile" :href="userProfile(userProfileUrl)" class="author-name">
          {{ userNick }}
          <div v-if="showLogginOptions" class="login-options">
              <span>Solo los socios y socias pueden acceder a los perfiles.</span>
              <a :href="loginUrl">Inicia Sesión</a> o <a :href="partnerUrl">Hazte Socio/a</a>
          </div>
      </a>
    </div>
    <p class="publicationDate">{{ publicationDate|formatDate }}</p>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    props: {
      num: Number,
      userNick: String,
      publicationDate: Object|String,
      userProfileUrl: String
    },
    computed: {
      ...mapGetters([
        'userProfile',
        'isLogged',
        'partnerUrl',
        'profileUrl',
        'loginUrl',
      ])
    },
    data () {
        return {
            showLogginOptions: false,
        }
    },
    methods: {
        showProfile() {
            if (!this.isLogged) {
                this.showLogginOptions = !this.showLogginOptions;
                setTimeout(this.closeOptions, 3000);
            } else {
                this.$emit('click');
            }
        },
        closeOptions() {
            this.showLogginOptions = false;
        }
    }
  }
</script>
